<template>
    <div @click="copy(source)" class="inline-block" v-if="isSupported">
        <Tippy v-if="copied" show-on-create>
            <IconClipboardCheck class="w-6 h-6 text-green-500" />
            <template #content>
                {{ $t('messages.copied_to_clipboard') }}
            </template>
        </Tippy>
        <Tippy v-else>
            <IconClipboardList class="w-6 h-6 text-gray-400" />
            <template #content>
                {{ $t('messages.copy_to_clipboard') }}
            </template>
        </Tippy>
    </div>
</template>

<script>
import { IconClipboardCheck, IconClipboardList } from '@tabler/icons-vue';
import { Tippy } from 'vue-tippy';

export default {
    name: 'CopyToClipboard',
    components: {
        IconClipboardList,
        IconClipboardCheck,
        Tippy,
    },
};
</script>
<script setup>
import { ref } from 'vue';
import { useClipboard } from '@vueuse/core';

const props = defineProps({
    content: {
        type: String,
        required: true,
    },
});

const source = ref(props.content);
const { copy, copied, isSupported } = useClipboard({ source });
</script>
